function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { getTransitionShorthand } from "../foundations/transition";
var parts = ["dialogContainer", "dialog", "header", "closeButton", "body"];

// modal controlled by inbound url
var baseStyleDialogContainer = props => {
  var _props$alignTo;

  return {
    display: "none",
    position: "fixed",
    [(_props$alignTo = props.alignTo) != null ? _props$alignTo : "left"]: 0,
    top: 0,
    width: "full",
    height: "full",
    zIndex: "modal",
    _target: {
      display: "block"
    }
  };
};

var baseStyleDialog = props => {
  var _props$alignTo2;

  return {
    pos: "fixed",
    p: 0,
    [(_props$alignTo2 = props.alignTo) != null ? _props$alignTo2 : "left"]: "50vw",
    top: "50%",
    transform: props.alignTo === "right" ? "translateX(50%)" : "translateX(-50%)",
    zIndex: "modal",
    overflowY: "auto",
    bg: "white",
    color: "inherit",
    maxH: "100%",
    transition: getTransitionShorthand()
  };
};

var baseStyleHeader = {
  px: 6,
  py: 4,
  fontSize: "xl",
  fontWeight: "semibold"
};

function closeButton(_ref) {
  var {
    closeButtonVariant
  } = _ref;
  var baseStyle = {
    color: "text",
    position: "absolute",
    right: 1,
    top: 1,
    padding: 1
  };

  var style = _extends({}, baseStyle);

  if (closeButtonVariant === "circle") {
    Object.assign(style, {
      color: "gray",
      border: "1px",
      borderColor: "gray",
      borderRadius: "50%"
    });
  }

  return style;
}

var baseStyleBody = {
  display: "block",
  p: 8,
  overflow: "auto"
};

var baseStyle = props => ({
  dialogContainer: baseStyleDialogContainer,
  dialog: baseStyleDialog(props),
  header: baseStyleHeader,
  closeButton: closeButton(props),
  body: baseStyleBody
});
/**
 * Since the `maxWidth` prop references theme.sizes internally,
 * we can leverage that to size our modals.
 */


function getSize(value) {
  if (value === "full") {
    return {
      dialog: {
        w: "100vw",
        h: "100vh"
      }
    };
  }

  if (value === "sm") {
    return {
      dialog: {
        minH: "3xs",
        maxH: "container.sm",
        width: "xl"
      }
    };
  }

  if (value === "md") {
    return {
      dialog: {
        minH: "sm",
        maxH: "container.sm",
        width: "container.md"
      }
    };
  }

  if (value === "lg") {
    return {
      dialog: {
        height: "3xl",
        width: "6xl"
      }
    };
  }

  if (value === "almostFull") {
    return {
      dialog: {
        width: "full",
        height: "full",
        mx: 6
      }
    };
  }

  return {
    dialog: {
      maxW: "100vw",
      minH: "100vh"
    }
  };
}

var sizes = {
  sm: getSize("sm"),
  md: getSize("md"),
  lg: getSize("lg"),
  full: getSize("full"),
  almostFull: getSize("almostFull")
};
var defaultProps = {
  size: "md"
};
export default {
  parts,
  baseStyle,
  sizes,
  defaultProps
};
//# sourceMappingURL=modal.js.map